// extracted by mini-css-extract-plugin
export var container = "_d0-1";
export var cornerButtonContainer = "_d0-6";
export var disabled = "_d0-2";
export var dragActive = "_d0-3";
export var fileContainer = "_d0-5";
export var hiddenInput = "_d0-4";
export var widthContainer = "_d0-0";